import { render, staticRenderFns } from "./SimplePopup.vue?vue&type=template&id=65576d47&scoped=true&"
import script from "./SimplePopup.vue?vue&type=script&lang=js&"
export * from "./SimplePopup.vue?vue&type=script&lang=js&"
import style0 from "./SimplePopup.vue?vue&type=style&index=0&id=65576d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65576d47",
  null
  
)

export default component.exports